// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.trimble-search .sui-layout-sidebar {
  padding: 0.25rem 3rem 2.125rem 0;
  gap: 1.5rem !important;
  height: fit-content;
  min-width: 33% !important;
  border-right: 1px solid #6a6e79;
}

.trimble-search .sui-layout-sidebar .sui-layout-sidebar__inner {
  display: flex !important;
  flex-direction: column !important;
  gap: 1.5rem !important;
}

.trimble-search .sui-layout-sidebar .search-field {
  padding: 0;
}

.trimble-search .sui-layout-sidebar .facet-list .sub-facets {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.75rem;
  align-self: stretch;
  gap: 0.75rem;

  margin-top: 1.5em;
  margin-left: 0.94rem;
  padding-left: 1.5em;
  border-left: 2px solid #6a6e79;
}

.trimble-search .sui-layout-sidebar .sui-facet {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.5rem;
  align-self: stretch;
  margin: 0;
  width: 100%;
}

.trimble-search .sui-layout-sidebar .facet-list .sub-facets h3 {
  font-size: 1rem;
  font-style: normal;
  font-weight: 600;
  line-height: 1.5rem;
  letter-spacing: 0.0015rem;
}

.trimble-search .sui-layout-sidebar .facet-list .sub-facets + .option {
  margin-top: 1.5em;
}

.trimble-search .sui-layout-sidebar .facet-list .facet-title {
  display: flex;
  padding: 0.25rem 0;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
}

.trimble-search .sui-layout-sidebar .facet-list .facet-title:hover {
  cursor: pointer;
}

.trimble-search .sui-layout-sidebar .facet-list .facet-title:hover h3 {
  color: var(--primary-black-opacity-60) !important;
}

.trimble-search .sui-layout-sidebar .facet-list .sui-facet.disabled .facet-title h3 {
  color: #9a9a9e !important;
}

.trimble-search .sui-layout-sidebar .facet-list .sui-facet.disabled .facet-title svg > path {
  fill: #9a9a9e !important;
}

.trimble-search .sui-layout-sidebar .facet-list .sui-facet.disabled .facet-title:hover h3 {
  color: rgb(154, 154, 158, 0.6) !important;
}

.trimble-search .sui-layout-sidebar .facet-list .facet-title > svg {
  height: 1.5rem;
  width: 1.5rem;
}

.trimble-search .sui-layout-sidebar .facet-list .facet-title > svg path {
  fill: var(--primary-black) !important;
}

.trimble-search .sui-layout-sidebar .facet-list .sui-facet button.show-more-options {
  display: flex;
  justify-content: center;
  align-items: center;

  padding: 0 0.5rem;
  margin-top: 0.5rem;
  gap: 0.25rem;
  height: 1.5rem;

  background-color: transparent;
  border: 0;
  border-radius: 0.5rem;
  cursor: pointer;

  font-family: "Open Sans", sans-serif;
  font-size: 0.875rem;
  font-style: normal;
  text-decoration: underline;
  font-weight: 700;
  line-height: 1.5rem;
  letter-spacing: 0.00188rem;
  color: var(--primary-black);
}

.trimble-search .sui-layout-sidebar .facet-list .sui-facet button.show-more-options:hover,
.trimble-search .sui-layout-sidebar .facet-list .sui-facet button.show-more-options:focus {
  background-color: var(--button-hover-bg-color);
}

.trimble-search .sui-layout-sidebar .facet-list .sui-facet button.show-more-options svg {
  width: 12px;
  height: 12px;
  aspect-ratio: 1 / 1;
}

.trimble-search .sui-layout-sidebar .facet-list .sui-facet button.show-more-options svg path {
  fill: var(--primary-black) !important;
}

.trimble-search .sui-layout-sidebar .facet-list .disabled .small-text {
  font-weight: normal;
}

.trimble-search .sui-layout-sidebar .facet-list .sui-facet .options {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.25rem;
  align-self: stretch;
}

.trimble-search .sui-layout-sidebar .facet-list .sui-facet .options .option {
  display: flex;
  padding-right: 0.5rem;
  align-items: center;
  gap: 0.5rem;
  align-self: stretch;
}

.trimble-search .sui-layout-sidebar .facet-list .sui-facet .options .option .facet-result-count {
  color: #6a6e79 !important;
  text-align: right;
  font-weight: normal;
}

.trimble-search .sui-layout-sidebar .facet-list .sui-facet .options .option input[type="checkbox"],
.trimble-search .sui-layout-sidebar .facet-list .sui-facet .options .option .radio-button-input,
.trimble-search .sui-layout-sidebar .facet-list .sui-facet .options .option .checkbox-input {
  cursor: pointer;
}

.trimble-search .sui-layout-sidebar .facet-list .sui-facet .options .option .checkbox,
.trimble-search .sui-layout-sidebar .facet-list .sui-facet .options .option .radio {
  display: flex !important;
  margin: 0 !important;
  align-items: center;
  font-size: 2rem;
  color: #363545;
}

.trimble-search .sui-layout-sidebar .facet-list .sui-facet .options .option .checkbox-input {
  display: -ms-grid;
  display: grid;
  grid-template-areas: "checkbox";
}

.trimble-search .sui-layout-sidebar .facet-list .sui-facet .options .option .radio-button-input {
  width: 1.5rem;
  height: 1.5rem;
}

.trimble-search .sui-layout-sidebar .facet-list .sui-facet .options .option .radio-button-label,
.trimble-search .sui-layout-sidebar .facet-list .sui-facet .options .option .checkbox-label {
  color: var(--primary-black) !important;
  font-family: "Open Sans", sans-serif;
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 400;
  line-height: 1.3125rem;
  letter-spacing: 0.00131rem;
  cursor: pointer;
}

.trimble-search .sui-layout-sidebar .facet-list .sui-facet .options .option .radio-button,
.trimble-search .sui-layout-sidebar .facet-list .sui-facet .options .option .checkbox {
  display: flex;
  padding: 0.25rem;
  align-items: center;
  gap: 0.5rem;
  flex: 1 0 0;
  flex-grow: 1;
}

.trimble-search .sui-layout-sidebar .facet-list .sui-facet .options .option .radio-button:focus,
.trimble-search .sui-layout-sidebar .facet-list .sui-facet .options .option .checkbox:focus {
  outline: 2px solid #004f83;
}

.trimble-search .sui-layout-sidebar .facet-list .sui-facet .options .option .radio-button span.radio-button-input input,
.trimble-search .sui-layout-sidebar .facet-list .sui-facet .options .option .checkbox span.checkbox-input input {
  opacity: 0;
  width: 0;
  height: 0;
  display: none;
}

.trimble-search .sui-layout-sidebar .sidebar-actions {
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  gap: 0.5rem;
  align-self: stretch;
}

.trimble-search .sui-layout-sidebar button.save-filters-button,
.trimble-search .sui-layout-sidebar button.clear-filters-button {
  display: flex;
  height: 2.5rem;
  padding: 0 1rem;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;

  border-radius: 1000px;
  border: 1px solid var(--primary-black);
  background-color: #ffffff;
  color: var(--primary-black);

  font-family: "Open Sans", sans-serif;
  font-size: 1rem;
  font-style: normal;
  font-weight: 600;
  line-height: 1.75rem;
  letter-spacing: 0.00131rem;

  cursor: pointer;
}

.trimble-search .sui-layout-sidebar button.save-filters-button {
  border-radius: 1000px;
  background: #fbad26;
  border: 1px solid #fbad26;

  /* hide on desktop view */
  display: none;
}

.trimble-search .sui-layout-sidebar button.save-filters-button:hover,
.trimble-search .sui-layout-sidebar button.clear-filters-button:hover {
  background: var(--button-hover-bg-color);
}

.trimble-search .sui-layout-sidebar button.save-filters-button:focus,
.trimble-search .sui-layout-sidebar button.clear-filters-button:focus {
  background: var(--button-hover-bg-color);
  border: 2px solid var(--primary-black);
}

/* RESPONSIVENESS */

@media (max-width: 975px) {
  .trimble-search .sui-layout-sidebar {
    width: 40% !important;
  }
}

@media (max-width: 800px) {
  .trimble-search .sui-layout-sidebar {
    width: 100% !important;
  }

  .trimble-search .sui-layout-sidebar .sui-layout-sidebar__inner h2 {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
  }

  .trimble-search .sui-layout-sidebar .sui-layout-sidebar__inner h2 > button.close-sidebar {
    background-color: transparent;
    border: none;
    display: flex;
    margin: 0;
    width: fit-content;
    width: -moz-fit-content;
    width: auto;
  }

  .trimble-search button.sui-layout-sidebar-toggle.close-sidebar:hover {
    background-color: unset;
  }

  .trimble-search button.sui-layout-sidebar-toggle.close-sidebar:focus {
    background-color: unset;
  }

  .trimble-search .sui-layout-sidebar .sui-layout-sidebar__inner h2 > button > svg path {
    fill: #0063a3;
  }

  .trimble-search .sui-layout-sidebar.sui-layout-sidebar--toggled {
    display: flex;
    z-index: 10;
    box-shadow: 0px 4px 16px #00000029;
    height: 100vh;
    padding: 0;
  }

  .trimble-search .sui-layout-sidebar.sui-layout-sidebar--toggled .sui-layout-sidebar__inner {
    width: 100%;
    padding: 2rem;
  }

  .trimble-search .sui-layout-sidebar.sui-layout-sidebar--toggled .sidebar-actions {
    padding-bottom: 2rem;
  }

  .trimble-search .sui-layout-sidebar.sui-layout-sidebar--toggled .save-filters-button {
    display: flex;
  }

  .trimble-search .mobile-sidebar-header {
    display: flex;
    position: relative;
    justify-content: center;
    align-items: center;
    background-color: #ffffff;
    color: inherit;
  }

  .trimble-search .button-wrapper .mobile-sidebar-header > h3 {
    margin: 0 !important;
    text-align: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/sidebar/sidebar.css"],"names":[],"mappings":"AAAA;EACE,gCAAgC;EAChC,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,YAAY;;EAEZ,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;EACX,mBAAmB;EACnB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;;EAEnB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,cAAc;;EAEd,6BAA6B;EAC7B,SAAS;EACT,qBAAqB;EACrB,eAAe;;EAEf,oCAAoC;EACpC,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;EAC1B,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;;EAEE,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;;;EAGE,eAAe;AACjB;;AAEA;;EAEE,wBAAwB;EACxB,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;;EAEE,sCAAsC;EACtC,oCAAoC;EACpC,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;;EAEE,UAAU;EACV,QAAQ;EACR,SAAS;EACT,aAAa;AACf;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,uBAAuB;EACvB,WAAW;EACX,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,cAAc;EACd,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;;EAEX,qBAAqB;EACrB,sCAAsC;EACtC,yBAAyB;EACzB,2BAA2B;;EAE3B,oCAAoC;EACpC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,0BAA0B;;EAE1B,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,yBAAyB;;EAEzB,yBAAyB;EACzB,aAAa;AACf;;AAEA;;EAEE,wCAAwC;AAC1C;;AAEA;;EAEE,wCAAwC;EACxC,sCAAsC;AACxC;;AAEA,mBAAmB;;AAEnB;EACE;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,6BAA6B;IAC7B,YAAY;IACZ,aAAa;IACb,SAAS;IACT,kBAAkB;IAClB,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,WAAW;IACX,kCAAkC;IAClC,aAAa;IACb,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,aAAa;EACf;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,oBAAoB;IACpB,kBAAkB;EACpB;AACF","sourcesContent":[".trimble-search .sui-layout-sidebar {\n  padding: 0.25rem 3rem 2.125rem 0;\n  gap: 1.5rem !important;\n  height: fit-content;\n  min-width: 33% !important;\n  border-right: 1px solid #6a6e79;\n}\n\n.trimble-search .sui-layout-sidebar .sui-layout-sidebar__inner {\n  display: flex !important;\n  flex-direction: column !important;\n  gap: 1.5rem !important;\n}\n\n.trimble-search .sui-layout-sidebar .search-field {\n  padding: 0;\n}\n\n.trimble-search .sui-layout-sidebar .facet-list .sub-facets {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0.75rem;\n  align-self: stretch;\n  gap: 0.75rem;\n\n  margin-top: 1.5em;\n  margin-left: 0.94rem;\n  padding-left: 1.5em;\n  border-left: 2px solid #6a6e79;\n}\n\n.trimble-search .sui-layout-sidebar .sui-facet {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0.5rem;\n  align-self: stretch;\n  margin: 0;\n  width: 100%;\n}\n\n.trimble-search .sui-layout-sidebar .facet-list .sub-facets h3 {\n  font-size: 1rem;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 1.5rem;\n  letter-spacing: 0.0015rem;\n}\n\n.trimble-search .sui-layout-sidebar .facet-list .sub-facets + .option {\n  margin-top: 1.5em;\n}\n\n.trimble-search .sui-layout-sidebar .facet-list .facet-title {\n  display: flex;\n  padding: 0.25rem 0;\n  justify-content: space-between;\n  align-items: center;\n  align-self: stretch;\n}\n\n.trimble-search .sui-layout-sidebar .facet-list .facet-title:hover {\n  cursor: pointer;\n}\n\n.trimble-search .sui-layout-sidebar .facet-list .facet-title:hover h3 {\n  color: var(--primary-black-opacity-60) !important;\n}\n\n.trimble-search .sui-layout-sidebar .facet-list .sui-facet.disabled .facet-title h3 {\n  color: #9a9a9e !important;\n}\n\n.trimble-search .sui-layout-sidebar .facet-list .sui-facet.disabled .facet-title svg > path {\n  fill: #9a9a9e !important;\n}\n\n.trimble-search .sui-layout-sidebar .facet-list .sui-facet.disabled .facet-title:hover h3 {\n  color: rgb(154, 154, 158, 0.6) !important;\n}\n\n.trimble-search .sui-layout-sidebar .facet-list .facet-title > svg {\n  height: 1.5rem;\n  width: 1.5rem;\n}\n\n.trimble-search .sui-layout-sidebar .facet-list .facet-title > svg path {\n  fill: var(--primary-black) !important;\n}\n\n.trimble-search .sui-layout-sidebar .facet-list .sui-facet button.show-more-options {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  padding: 0 0.5rem;\n  margin-top: 0.5rem;\n  gap: 0.25rem;\n  height: 1.5rem;\n\n  background-color: transparent;\n  border: 0;\n  border-radius: 0.5rem;\n  cursor: pointer;\n\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 0.875rem;\n  font-style: normal;\n  text-decoration: underline;\n  font-weight: 700;\n  line-height: 1.5rem;\n  letter-spacing: 0.00188rem;\n  color: var(--primary-black);\n}\n\n.trimble-search .sui-layout-sidebar .facet-list .sui-facet button.show-more-options:hover,\n.trimble-search .sui-layout-sidebar .facet-list .sui-facet button.show-more-options:focus {\n  background-color: var(--button-hover-bg-color);\n}\n\n.trimble-search .sui-layout-sidebar .facet-list .sui-facet button.show-more-options svg {\n  width: 12px;\n  height: 12px;\n  aspect-ratio: 1 / 1;\n}\n\n.trimble-search .sui-layout-sidebar .facet-list .sui-facet button.show-more-options svg path {\n  fill: var(--primary-black) !important;\n}\n\n.trimble-search .sui-layout-sidebar .facet-list .disabled .small-text {\n  font-weight: normal;\n}\n\n.trimble-search .sui-layout-sidebar .facet-list .sui-facet .options {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0.25rem;\n  align-self: stretch;\n}\n\n.trimble-search .sui-layout-sidebar .facet-list .sui-facet .options .option {\n  display: flex;\n  padding-right: 0.5rem;\n  align-items: center;\n  gap: 0.5rem;\n  align-self: stretch;\n}\n\n.trimble-search .sui-layout-sidebar .facet-list .sui-facet .options .option .facet-result-count {\n  color: #6a6e79 !important;\n  text-align: right;\n  font-weight: normal;\n}\n\n.trimble-search .sui-layout-sidebar .facet-list .sui-facet .options .option input[type=\"checkbox\"],\n.trimble-search .sui-layout-sidebar .facet-list .sui-facet .options .option .radio-button-input,\n.trimble-search .sui-layout-sidebar .facet-list .sui-facet .options .option .checkbox-input {\n  cursor: pointer;\n}\n\n.trimble-search .sui-layout-sidebar .facet-list .sui-facet .options .option .checkbox,\n.trimble-search .sui-layout-sidebar .facet-list .sui-facet .options .option .radio {\n  display: flex !important;\n  margin: 0 !important;\n  align-items: center;\n  font-size: 2rem;\n  color: #363545;\n}\n\n.trimble-search .sui-layout-sidebar .facet-list .sui-facet .options .option .checkbox-input {\n  display: -ms-grid;\n  display: grid;\n  grid-template-areas: \"checkbox\";\n}\n\n.trimble-search .sui-layout-sidebar .facet-list .sui-facet .options .option .radio-button-input {\n  width: 1.5rem;\n  height: 1.5rem;\n}\n\n.trimble-search .sui-layout-sidebar .facet-list .sui-facet .options .option .radio-button-label,\n.trimble-search .sui-layout-sidebar .facet-list .sui-facet .options .option .checkbox-label {\n  color: var(--primary-black) !important;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 0.875rem;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.3125rem;\n  letter-spacing: 0.00131rem;\n  cursor: pointer;\n}\n\n.trimble-search .sui-layout-sidebar .facet-list .sui-facet .options .option .radio-button,\n.trimble-search .sui-layout-sidebar .facet-list .sui-facet .options .option .checkbox {\n  display: flex;\n  padding: 0.25rem;\n  align-items: center;\n  gap: 0.5rem;\n  flex: 1 0 0;\n  flex-grow: 1;\n}\n\n.trimble-search .sui-layout-sidebar .facet-list .sui-facet .options .option .radio-button:focus,\n.trimble-search .sui-layout-sidebar .facet-list .sui-facet .options .option .checkbox:focus {\n  outline: 2px solid #004f83;\n}\n\n.trimble-search .sui-layout-sidebar .facet-list .sui-facet .options .option .radio-button span.radio-button-input input,\n.trimble-search .sui-layout-sidebar .facet-list .sui-facet .options .option .checkbox span.checkbox-input input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n  display: none;\n}\n\n.trimble-search .sui-layout-sidebar .sidebar-actions {\n  display: flex;\n  justify-content: flex-end;\n  align-items: flex-start;\n  gap: 0.5rem;\n  align-self: stretch;\n}\n\n.trimble-search .sui-layout-sidebar button.save-filters-button,\n.trimble-search .sui-layout-sidebar button.clear-filters-button {\n  display: flex;\n  height: 2.5rem;\n  padding: 0 1rem;\n  justify-content: center;\n  align-items: center;\n  gap: 0.5rem;\n\n  border-radius: 1000px;\n  border: 1px solid var(--primary-black);\n  background-color: #ffffff;\n  color: var(--primary-black);\n\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 1rem;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 1.75rem;\n  letter-spacing: 0.00131rem;\n\n  cursor: pointer;\n}\n\n.trimble-search .sui-layout-sidebar button.save-filters-button {\n  border-radius: 1000px;\n  background: #fbad26;\n  border: 1px solid #fbad26;\n\n  /* hide on desktop view */\n  display: none;\n}\n\n.trimble-search .sui-layout-sidebar button.save-filters-button:hover,\n.trimble-search .sui-layout-sidebar button.clear-filters-button:hover {\n  background: var(--button-hover-bg-color);\n}\n\n.trimble-search .sui-layout-sidebar button.save-filters-button:focus,\n.trimble-search .sui-layout-sidebar button.clear-filters-button:focus {\n  background: var(--button-hover-bg-color);\n  border: 2px solid var(--primary-black);\n}\n\n/* RESPONSIVENESS */\n\n@media (max-width: 975px) {\n  .trimble-search .sui-layout-sidebar {\n    width: 40% !important;\n  }\n}\n\n@media (max-width: 800px) {\n  .trimble-search .sui-layout-sidebar {\n    width: 100% !important;\n  }\n\n  .trimble-search .sui-layout-sidebar .sui-layout-sidebar__inner h2 {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    align-self: stretch;\n  }\n\n  .trimble-search .sui-layout-sidebar .sui-layout-sidebar__inner h2 > button.close-sidebar {\n    background-color: transparent;\n    border: none;\n    display: flex;\n    margin: 0;\n    width: fit-content;\n    width: -moz-fit-content;\n    width: auto;\n  }\n\n  .trimble-search button.sui-layout-sidebar-toggle.close-sidebar:hover {\n    background-color: unset;\n  }\n\n  .trimble-search button.sui-layout-sidebar-toggle.close-sidebar:focus {\n    background-color: unset;\n  }\n\n  .trimble-search .sui-layout-sidebar .sui-layout-sidebar__inner h2 > button > svg path {\n    fill: #0063a3;\n  }\n\n  .trimble-search .sui-layout-sidebar.sui-layout-sidebar--toggled {\n    display: flex;\n    z-index: 10;\n    box-shadow: 0px 4px 16px #00000029;\n    height: 100vh;\n    padding: 0;\n  }\n\n  .trimble-search .sui-layout-sidebar.sui-layout-sidebar--toggled .sui-layout-sidebar__inner {\n    width: 100%;\n    padding: 2rem;\n  }\n\n  .trimble-search .sui-layout-sidebar.sui-layout-sidebar--toggled .sidebar-actions {\n    padding-bottom: 2rem;\n  }\n\n  .trimble-search .sui-layout-sidebar.sui-layout-sidebar--toggled .save-filters-button {\n    display: flex;\n  }\n\n  .trimble-search .mobile-sidebar-header {\n    display: flex;\n    position: relative;\n    justify-content: center;\n    align-items: center;\n    background-color: #ffffff;\n    color: inherit;\n  }\n\n  .trimble-search .button-wrapper .mobile-sidebar-header > h3 {\n    margin: 0 !important;\n    text-align: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
